// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__agEkA","rootMobile":"styles_rootMobile__2OCEq"};